import { deleteProductCategoryMeasureValues } from './deleteProductCategoryMeasureValues';
import { getProductCategories } from './getProductCategories';
import { getProductCategoryMeasureValues } from './getProductCategoryMeasureValues';

export const productCategoryService = {
  getProductCategories,
  getProductCategoryMeasureValues,
  deleteProductCategoryMeasureValues,
};
